module.exports = __webpack_public_path__ + "img/3_133.8bbe1040.png";